import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  CircularProgress,
  Divider,
  Fade,
  Slide,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ArrowForward, WhatsApp } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import ProductCard from "../../components/common/ProductCard";
import useHomeFeaturedProducts from "../../hooks/useHomeFeaturedProducts";
import { useSEO } from "../../hooks/useSEO";
import { CONTACT_INFO } from "../../constants/contactInfo";
import { PopularCategories } from "../../components/common/PopularCategories";
import CompaniesSection from "../../components/common/CompaniesSection";
import useResponsive from "../../hooks/useResponsive";
import CopyButton from "../../components/common/CopyButton";

const Home = () => {
  const navigate = useNavigate();
  const { isMobile } = useResponsive();

  // Hook para tracking de navegación

  // Usar hooks específicos para datos del home
  const {
    featuredProducts,
    loading: loadingFeatured,
    error: errorFeatured,
    isEmpty: isEmptyFeatured,
  } = useHomeFeaturedProducts();

  const [whatsappAnchor, setWhatsappAnchor] = useState(null);

  const handleWhatsAppMenuOpen = (event) => {
    setWhatsappAnchor(event.currentTarget);
  };

  const handleWhatsAppMenuClose = () => {
    setWhatsappAnchor(null);
  };

  const handleWhatsAppClick = (phone) => {
    const url = `https://wa.me/${phone.number.replace(/[\s+]/g, "")}`;
    window.open(url, "_blank");
    handleWhatsAppMenuClose();
  };

  // SEO para página principal
  useSEO({
    title: "Venta Usados Tattersall - Vehículos, Equipos y Maquinaria",
    description:
      "Encuentra vehículos, equipos, maquinarias y más en Venta Usados Tattersall. La mejor selección de productos usados con calidad garantizada y atención personalizada.",
    keywords:
      "venta usados, vehículos usados, maquinaria usada, equipos usados, tattersall, automóviles, camiones, camionetas",
    image: "/og-home.jpg",
    type: "website",
  });

  return (
    <>
      <Box>
        {/* Hero Section Mejorado */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #004b93 0%, #003366 100%)",
            color: "white",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <Container
            maxWidth="lg"
            sx={{
              py: 4,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 6 }}>
                <Fade in timeout={1000}>
                  <Box>
                    <Typography
                      variant={isMobile ? "h4" : "h3"}
                      component="h1"
                      fontWeight="bold"
                      gutterBottom
                    >
                      Venta Usados Tattersall
                    </Typography>
                    <Typography
                      variant={isMobile ? "h6" : "h5"}
                      component="h2"
                      sx={{ mb: 3, opacity: 0.9 }}
                    >
                      Vehículos, equipos, maquinarias y más en un solo lugar
                    </Typography>

                    {/* Botones de acción */}
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: isMobile ? "row" : "row",
                        gap: 2,
                        justifyContent: isMobile ? "center" : "flex-start",
                        // flexWrap: "wrap",
                        mt: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => navigate("/catalogo")}
                        sx={{
                          backgroundColor: "white",
                          color: "primary.main",
                          "&:hover": { backgroundColor: "#f5f5f5" },
                          px: 4,
                        }}
                      >
                        VER CATÁLOGO
                      </Button>
                      <Button
                        variant="outlined"
                        size="large"
                        onClick={() => navigate("/contacto")}
                        sx={{
                          borderColor: "white",
                          color: "white",
                          "&:hover": {
                            backgroundColor: "rgba(255,255,255,0.1)",
                          },
                          px: 4,
                        }}
                      >
                        CONTÁCTANOS
                      </Button>
                    </Box>
                  </Box>
                </Fade>
              </Grid>

              <Grid
                sx={{ display: isMobile ? "none" : "" }}
                size={{ xs: 12, md: 6 }}
              >
                {/* agregar un titulo que dihga explora nuestro catalogo */}
                <Typography
                  variant="h6"
                  component={"h2"}
                  fontWeight="bold"
                  gutterBottom
                  sx={{ mb: 3, textAlign: "center" }}
                >
                  Explora Nuestras Categorías Más Destacadas
                </Typography>
                <Slide
                  direction="up"
                  in
                  timeout={1000}
                  onClick={() => {
                    //navegar a catalogo
                    // navigate("/catalogo");
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      justifyContent: "center",
                      alignItems: "center",
                      // gap: 2,
                      // gridTemplateColumns: "repeat(3, 1fr)",
                      // gridTemplateRows: "repeat(2, 1fr)",
                      maxWidth: 450,
                      mx: "auto",
                    }}
                  >
                    {/* {featuredProducts.slice(0, 6).map((product) => (
                      <Box
                        key={product.id}
                        sx={{
                          maxWidth: 350,
                          // transform: "rotate(5deg)",
                          boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
                        }}
                      >
                        <ProductCard
                          mode="minimal"
                          product={product}
                          onCardClick={() => navigate(`/catalogo`)}
                        />
                      </Box>
                    ))} */}
                    <PopularCategories mode="minimal" />
                  </Box>
                </Slide>
              </Grid>
            </Grid>
          </Container>
        </Box>

        {/* Productos Destacados */}
        {!isEmptyFeatured && (
          <Container maxWidth="lg" sx={{ py: 8 }}>
            <Box sx={{ textAlign: "center", mb: 6 }}>
              <Typography
                variant="h4"
                component={"h3"}
                fontWeight="bold"
                gutterBottom
              >
                Productos Destacados
              </Typography>
              <Typography
                variant="h6"
                component={"h4"}
                color="text.secondary"
                gutterBottom
              >
                Los productos más recientes de nuestro catálogo
              </Typography>
              <Divider sx={{ width: 100, mx: "auto", mt: 2, borderWidth: 2 }} />
            </Box>

            {loadingFeatured ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                <CircularProgress size={60} />
              </Box>
            ) : errorFeatured ? (
              <Box sx={{ textAlign: "center", py: 4 }}>
                <Typography color="error">
                  Error cargando productos destacados
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={3}>
                {featuredProducts.map((product) => (
                  <Grid size={{ xs: 6, sm: 6, md: 4 }} key={product.id}>
                    <ProductCard
                      mode={isMobile ? "minimal" : "normal"}
                      favoriteButton={false}
                      product={product}
                    />
                  </Grid>
                ))}
              </Grid>
            )}

            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="outlined"
                size="large"
                endIcon={<ArrowForward />}
                onClick={() => navigate("/catalogo")}
              >
                Ver Todo el Catálogo
              </Button>
            </Box>
          </Container>
        )}

        {/* Categorías Populares - Versión Mejorada con Imágenes */}
        {/* <Box sx={{ backgroundColor: "#f8f9fa", py: 8 }}>
          <Container maxWidth="lg">
            <Box sx={{ textAlign: "center", mb: 6 }}>
              <Typography
                variant="h4"
                fontWeight="bold"
                gutterBottom
                sx={{
                  background: "linear-gradient(45deg, #004b93, #003366)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                }}
              >
                Categorías Más Destacadas
              </Typography>
              <Typography
                variant="h6"
                component={"h5"}
                color="text.secondary"
                sx={{ mb: 2 }}
              >
                Descubre nuestras categorías estrella con productos de calidad
              </Typography>
              <Box
                sx={{
                  width: 80,
                  height: 4,
                  backgroundColor: "primary.main",
                  mx: "auto",
                  borderRadius: 2,
                }}
              />
            </Box>

            <PopularCategories />

            <Box sx={{ textAlign: "center", mt: 6 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/catalogo")}
                sx={{
                  px: 6,
                  py: 2,
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  background: "linear-gradient(45deg, #004b93, #003366)",
                  boxShadow: "0 8px 24px rgba(0, 75, 147, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #003366, #002244)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 12px 32px rgba(0, 75, 147, 0.4)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Ver Todas las Categorías
              </Button>
            </Box>
          </Container>
        </Box> */}

        {/* Sección de Confianza y Transparencia */}
        <Box
          sx={{
            py: 8,
            position: "relative",
            overflow: "hidden",
            background: "#ffffff",
          }}
        >
          <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
            {/* Header de la sección */}
            <Box sx={{ textAlign: "center", mb: 6 }}>
              <Typography
                variant="h3"
                component="h2"
                fontWeight="bold"
                gutterBottom
                color="primary.main"
                sx={{ mb: 2 }}
              >
                Compra con Total Confianza
              </Typography>
              <Typography
                variant="h6"
                color="text.secondary"
                sx={{ maxWidth: 800, mx: "auto", mb: 3 }}
              >
                Tu tranquilidad es nuestra prioridad. Cada vehículo y maquinaria
                pasa por un riguroso proceso de validación
              </Typography>
              <Box
                sx={{
                  width: 100,
                  height: 4,
                  backgroundColor: "primary.main",
                  mx: "auto",
                  borderRadius: 2,
                }}
              />
            </Box>

            {/* Contenido principal con tarjeta destacada */}
            <Grid
              container
              spacing={4}
              justifyContent={"center"}
              alignItems="center"
            >
              {/* Tarjeta principal con el mensaje */}
              <Grid size={{ xs: 12, md: 10 }}>
                <Box
                  sx={{
                    position: "relative",
                    p: 4,
                    borderRadius: 2,
                    backgroundColor: "primary.main",
                    color: "white",
                    boxShadow: "0 4px 12px rgba(0, 75, 147, 0.15)",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="h5"
                    fontWeight="bold"
                    sx={{
                      mb: 3,
                      lineHeight: 1.5,
                    }}
                  >
                    Prueba vehículos y maquinarias con test drive, revisa con tu
                    mecánico de confianza y realiza un escaneo completo. ¡Decide
                    con total confianza y sin sorpresas!
                  </Typography>

                  {/* Características destacadas */}
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                  >
                    {[
                      {
                        icon: "✓",
                        text: "Test drive sin compromiso",
                      },
                      {
                        icon: "✓",
                        text: "Revisión con tu mecánico de confianza",
                      },
                      {
                        icon: "✓",
                        text: "Escaneo completo del vehículo",
                      },
                    ].map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          p: 2,
                          borderRadius: 1,
                          backgroundColor: "rgba(255, 255, 255, 0.15)",
                        }}
                      >
                        <Box
                          sx={{
                            width: 28,
                            height: 28,
                            borderRadius: "50%",
                            backgroundColor: "white",
                            color: "primary.main",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontWeight: "bold",
                            fontSize: "1rem",
                            flexShrink: 0,
                          }}
                        >
                          {item.icon}
                        </Box>
                        <Typography variant="body1" fontWeight="medium">
                          {item.text}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Grid>

              {/* Tarjetas de beneficios adicionales */}
              {/* <Grid size={{ xs: 12, md: 5 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 3,
                    height: "100%",
                  }}
                >
                  {[
                    {
                      icon: "🔍",
                      title: "Inspección Completa",
                      description:
                        "Todos nuestros vehículos pasan por una inspección técnica rigurosa",
                    },
                    {
                      icon: "📋",
                      title: "Historial Transparente",
                      description:
                        "Acceso completo al historial de mantenimiento y documentación",
                    },
                    {
                      icon: "🤝",
                      title: "Garantía de Calidad",
                      description:
                        "Respaldamos la calidad de cada producto en nuestro catálogo",
                    },
                  ].map((benefit, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 3,
                        borderRadius: 2,
                        border: "1px solid",
                        borderColor: "divider",
                        backgroundColor: "#f8f9fa",
                        flex: 1,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                          mb: 1.5,
                        }}
                      >
                        <Typography sx={{ fontSize: "1.8rem" }}>
                          {benefit.icon}
                        </Typography>
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color="primary.main"
                        >
                          {benefit.title}
                        </Typography>
                      </Box>
                      <Typography variant="body2" color="text.secondary">
                        {benefit.description}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              </Grid> */}
            </Grid>

            {/* Call to Action */}
            <Box sx={{ textAlign: "center", mt: 6 }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/catalogo")}
                sx={{
                  px: 6,
                  py: 2,
                  borderRadius: 3,
                  textTransform: "none",
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  background: "linear-gradient(45deg, #004b93, #003366)",
                  boxShadow: "0 8px 24px rgba(0, 75, 147, 0.3)",
                  "&:hover": {
                    background: "linear-gradient(45deg, #003366, #002244)",
                    transform: "translateY(-2px)",
                    boxShadow: "0 12px 32px rgba(0, 75, 147, 0.4)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Explora Nuestro Catálogo con Confianza
              </Button>
            </Box>
          </Container>
        </Box>

        {/* CTA Section */}
        <Box
          sx={{
            background: "linear-gradient(135deg, #004b93 0%, #003366 100%)",
            color: "white",
            py: 8,
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={4} alignItems="center">
              <Grid size={{ xs: 12, md: 7 }}>
                <Typography variant="h4" fontWeight="bold" gutterBottom>
                  ¿Listo para encontrar tu próximo equipo?
                </Typography>
                <Typography variant="h6" component={"h5"} sx={{ opacity: 0.9 }}>
                  Nuestro equipo está listo para ayudarte. Llámanos a cualquiera
                  de nuestras líneas directas
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: 5 }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {CONTACT_INFO.phones && (
                    <>
                      {CONTACT_INFO.phones.map((phone) => {
                        return (
                          <>
                            <Button
                              variant="contained"
                              size="large"
                              fullWidth
                              startIcon={
                                <CopyButton
                                  text={phone.number}
                                  id={`${phone.number}`}
                                  showFeedback={false}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                  }}
                                />
                              }
                              href={`tel:${phone.number.replace(/\s/g, "")}`}
                              sx={{
                                backgroundColor: "white",
                                color: "primary.main",
                                transition: "all 0.2s ease",
                                justifyContent: "flex-start",
                                px: 3,
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "flex-start",
                                  ml: 1,
                                }}
                              >
                                <Typography
                                  variant="caption"
                                  sx={{ fontSize: "0.7rem", opacity: 0.7 }}
                                >
                                  {phone.label}
                                </Typography>

                                <Typography variant="body1" fontWeight="bold">
                                  {phone.number}
                                </Typography>
                              </Box>
                            </Button>
                          </>
                        );
                      })}
                    </>
                  )}

                  {/* WhatsApp */}
                  <Button
                    variant="outlined"
                    size="large"
                    fullWidth
                    startIcon={<WhatsApp />}
                    onClick={handleWhatsAppMenuOpen}
                    // href={`https://wa.me/${CONTACT_INFO.phones[0].number.replace(
                    //   /[\s+]/g,
                    //   ""
                    // )}`}
                    target="_blank"
                    sx={{
                      borderColor: "white",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.1)",
                        transform: "translateY(-2px)",
                        borderColor: "#25D366",
                        color: "#25D366",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    Escríbenos por WhatsApp
                  </Button>
                </Box>
              </Grid>
              <Menu
                anchorEl={whatsappAnchor}
                disableScrollLock
                open={Boolean(whatsappAnchor)}
                onClose={handleWhatsAppMenuClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                {CONTACT_INFO.phones
                  .filter((phone) => phone.whatsapp)
                  .map((phone, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleWhatsAppClick(phone)}
                    >
                      <ListItemIcon>
                        <WhatsApp fontSize="small" sx={{ color: "#25D366" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary={phone.label}
                        secondary={phone.number}
                      />
                    </MenuItem>
                  ))}
              </Menu>
            </Grid>
          </Container>
        </Box>
      </Box>
    </>
  );
};

export default Home;
